import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { onIdTokenChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore/lite';

import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSM from '../../components/Footers/FooterSmall.js';
import SelectNftTypeComponent from '../../components/MintNft/selectNftType';
import { firebaseAuthFunc } from '../../config/firebaseAuth.js';
import { firebaseFireStore } from '../../config/firebaseFirestore.js';

export default function MintNft() {
  const [userP2Detail, setUserP2Detail] = useState(false);
  const [userDetail, setUserDetail] = useState({});
  //Change
  const [apiCalled, setApiCalled] = useState(false);
  const router = useRouter();

  // Minting disabled - Relysia discontinued
  useEffect(() => {
    router.replace('/');
  }, []);

  /* Original auth check - disabled
  useEffect(() => {
    onIdTokenChanged(firebaseAuthFunc, (user, err) => {
      if (!user) {
        router.push('/auth/login?page=mintNFT');
      } else {
        getUserData(user.uid);
      }
    });
  }, []);
  */

  const getUserData = async (uid) => {
    try {
      const dbDoc = await getDoc(doc(firebaseFireStore, 'PIIDetails', uid));
      if (dbDoc.exists) {
        const data = dbDoc.data() ? dbDoc.data() : {};
        setUserDetail(data);
        setApiCalled(true);
        setUserP2Detail(true);
      }
    } catch (err) {
      setApiCalled(true);
    }
  };

  const SEO = {
    title: 'MusicArt | MintNft',
    discription: 'Type your keywords',
    canonical: 'https://musicart.io/mintNFT',
  };

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        {/* <Link  rel="canonical" href="https://musicart.io/mintnft" /> */}
      </Head>
      <NextSeo {...SEO} />
      {/* //indexcomment */}

      <div className="relative bg-white">
        <Navbar transparent />
        <SelectNftTypeComponent
          userP2Detail={userP2Detail}
          userDetail={userDetail}
          apiCalled={apiCalled}
        />
        <Footer />
        <FooterSM />
      </div>
    </>
  );
}
